<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic></Basic>

      <!--规格设置-->
      <Spec></Spec>

      <!--商品详情-->
      <Content></Content>

      <!--商品活动-->
      <Activity></Activity>

      <!--高级设置-->
      <Buyset></Buyset>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>
        <el-button size="small" type="primary" @click="Draft" :loading="loading">保存为草稿</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import Activity from './part/Activity.vue';
import Buyset from './part/Buyset.vue';
export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*活动设置*/
    Activity,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        model: {
          /*商品名称*/
          product_name:'',
          /*商品编码*/
          product_no:'',
          /*商品分类*/
          category_id: null,
          /*商品图片*/
          image: [],
          /*商品卖点*/
          selling_point:'',
          /*分销类型*/
          commission_type:0,
          /*规格类别,默认10单规格，20多规格*/
          spec_type: 10,
          /*库存计算方式,默认20付款减库存，10下单减库存*/
          deduct_stock_type: 20,
          /*检查用户等级*/
          is_alone_grade: 0,
          /*活动类型 0 视频 1 活动 2普通*/
          virtual_type:0,
          /*是否关联课程 0 否 1 是*/
          is_course:1,
          /*活动数据*/
          active:{
            active_time:'',
            name:'',
            address:'',
            mobile:'',
            dec:'',
            number:1,
            coordinate:'',
          },
          // 返利赠送规则
          balance_setting:{
            open:0,
            balance_type:10,
            balance_amount:0,
          },
          points_setting:{
            open:0,
            rule_type:0,
            points_type:10,
            points_amount:0,
          },
          /*课程*/
          course:'',
          sku: {},
          /*多规格类别*/
          spec_many: {
            /*多规格类别*/
            spec_attr: [],
            /*多规格表格数据*/
            spec_list: []
          },
          /*购买权限详情*/
          buy_auth:[],
          /*查看权限详情*/
          check_auth:[],
          /*免费观看课程权限*/
          watch_auth:[],
          /*商品详情内容*/
          content: '',
          /*运费模板ID*/
          delivery_id: '',
          store_id: '',
          /*商品状态*/
          product_status: 10,
          product_status_time: '',
          /*初始销量*/
          sales_initial: 0,
          view_times_initial: 0,
          /*商品排序，默认100*/
          product_sort: 100,
          /*是否开启积分赠送,默认1为开启，0为关闭*/
          is_points_gift: 0,
          /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
          is_points_discount: 0,
          /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
          is_enable_grade: 0,
          /*等级金额类型,默认10为百分比，20为固定金额*/
          alone_grade_type: 10,
          /*是否开启单独分销,默认0为关闭，1为开启*/
          is_ind_agent: 0,
          /*分销类型 0 统一 1 按等级*/
          commission_type:0,
          /*分销佣金类型,默认10为百分比，20为固定金额*/
          agent_money_type: 10,
          /*积分抵扣类型,默认10为百分比，20为固定金额*/
          alone_credit_type:10,
          /*一级佣金*/
          first_money:0,
          /*二级佣金*/
          second_money:0,
          /*三级佣金*/
          third_money:0,
          /*一级佣金复购*/
          first_money_member:0,
          /*二级佣金复购*/
          second_money_member:0,
          /*三级佣金复购*/
          third_money_member:0,
          // 渠道分销奖励
          distrbution_money:0,
          /*一级积分*/
          first_point: 0,
          /*二级积分*/
          second_point: 0,
          /*三级积分*/
          third_point: 0,
          /*会员折扣极差设置,默认0为关闭，1为开启*/
          is_enable_grade_discount:0,
          /*代理极差设置,默认0为关闭，1为开启*/
          is_alone_enable_grade_equity:0,
          // 返佣类型 10 百分比，20 固定金额
          alone_enable_grade_type:10,
          /*商品关联云仓设置,默认1为允许，0为不允许*/
          is_use_warehouse_product:0,
          /*云仓商品列表*/
          warehouse_product_list:[],
          /*是否虚拟商品*/
          is_virtual: 0,
          /*升级的等级*/
          up_grade_id: '',
          is_grade_goods: 0,
           // 三方卡券id
           gcard_id: '',
          supplier_id: '',
          /*单次限购数量*/
          buy_limit_num: 0,
          /*累计限购数量*/
          buy_total_num: 0,
          /*积分抵扣*/
          points_discount: 0,
          label_id: [],//标签集合
          is_recommend: false,  //推荐
          is_hot: false, // 热卖
          is_new: false, //新品
          poster: '',//视频封面
          video: '',//视频
          skucate:[],// sku 分类
          platform_commission: 0,
          is_commission_pay: 0,   //佣金支付
          is_cart: 1,   //允许加入购物车
          // 2+1链动参数
          boss_agent:{
            open:0,
            agent_money:0,//代理直推
            boss_money:0,//老板直推
            boss_peer:0,//老板直推平级奖励
            agent_level_money:0,//代理层级固定返利，直推多少个代理可享受对应几代的返利
          },
          earning_setting:{
            type:0,
            rate:0,//代理直推
            month:12,//托管月份
            limit_days:10,//收益产生开始时间n天后
          },
         //区域奖励参数
          area_agent:{
            open:0,
            agent_area_type:10,/*区域奖励类型,默认10为百分比，20为固定金额*/
            province_rate:0,//省级区域奖励
            city_rate:0,//市级区域奖励
            region_rate:0,//区级区域奖励
          },
          open_min_buy: 0,
          is_multiple: 0,
          buy_total_set: '',
          pick_total_set: '',
          custom_remark: '',
          custom_poster: '',
        },
        skucate:[],
        /*商品分类*/
        catgory: [],
        /*标签*/
        label: [],
        /*运费模板*/
        delivery: [],
        store_list:[],
        /*会员等级*/
        gradeList: [],
        supplierList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*是否锁住活动类型*/
        isTypeLocked: false,
        /*分销基础设置*/
        basicSetting: {},
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created() {

    /*获取基础数据*/
    this.getBaseData();

  },
  methods: {

    /*获取基础数据*/
    getBaseData: function() {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.loading = false;
          Object.assign(self.form, res.data);
          self.form.gradeList.forEach(item=>{
            self.$set(item, 'first_money', 0)
            self.$set(item, 'second_money', 0)
            self.$set(item, 'third_money',0)
            self.$set(item, 'first_money_member', 0)
            self.$set(item, 'second_money_member', 0)
            self.$set(item, 'third_money_member',0)
            self.$set(item, 'first_point', 0)
            self.$set(item, 'second_point', 0)
            self.$set(item, 'third_point',0)
            self.$set(item, 'push',0),
            self.$set(item, 'buy_total_set',0)
            self.$set(item, 'pick_total_set',0)
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_equity;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertBonusJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_bonus ? item.product_bonus: 0;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertMoneyJson(list){
      let obj={};
      let obj1={};
      let obj2={};
      let obj11={};
      let obj21={};
      let obj31={};
      let obj3={};
      let obj4={};
      let obj5={};
      let arr ={};
      list.forEach(item=>{
        obj[item.grade_id]=item.first_money;
        obj1[item.grade_id]=item.second_money;
        obj2[item.grade_id]=item.third_money;
        obj11[item.grade_id]=item.first_money_member;
        obj21[item.grade_id]=item.second_money_member;
        obj31[item.grade_id]=item.third_money_member;
        obj3[item.grade_id]=item.first_point;
        obj4[item.grade_id]=item.second_point;
        obj5[item.grade_id]=item.third_point;
      });
      arr['first_money'] = obj;
      arr['second_money'] = obj1;
      arr['third_money'] = obj2;
      arr['first_money_member'] = obj11;
      arr['second_money_member'] = obj21;
      arr['third_money_member'] = obj31;
      arr['first_point'] = obj3;
      arr['second_point'] = obj4;
      arr['third_point'] = obj5;
      return JSON.stringify(arr);
    },
    /*转JSON字符串*/
    convertEnableJson(list){
      let obj=[];
      list.forEach(item=>{
        if(item.grade_id){
          obj[item.grade_id] = {'grade_award':item.grade_award ? item.grade_award: 0,'same_award':item.same_award ? item.same_award: 0};
        }
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertBuyJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.buy_total_set ? item.buy_total_set: 0;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertPickJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.pick_total_set ? item.pick_total_set: 0;
      });
      return JSON.stringify(obj);
    },
    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      params.is_hot = self.form.model.is_hot ? 1: 0;
      params.is_recommend = self.form.model.is_recommend ? 1: 0;
      params.is_new = self.form.model.is_new ? 1: 0;
      if(params.virtual_type ==2){
        if(!params.course){
          self.$message({
            message: '请选择关联课程',
            type: 'error'
          });
          return;
        }
      }
      if(params.virtual_type ==3){
        if(!params.store_id){
          self.$message({
            message: '请选择景区门店',
            type: 'error'
          });
          return;
        }
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.active =JSON.stringify(params.active);
          params.alone_grade_equity=self.convertJson(self.form.gradeList);
          params.alone_bonus_equity=self.convertBonusJson(self.form.gradeList);
          params.alone_money_equity=self.convertMoneyJson(self.form.gradeList);
          params.alone_enable_grade_equity=self.convertEnableJson(self.form.gradeRangeList);
          params.buy_total_set=self.convertBuyJson(self.form.gradeList);
          params.pick_total_set=self.convertPickJson(self.form.gradeList);
          PorductApi.addProduct({
            params: JSON.stringify(params)
          }, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/product/product/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/add.vue